import { ERROR_MESSAGES } from '@/utils/defaultErrorMsg'

export const STEPS_ROUTES = {
  CPF: 'cpf',
  ACCOUNT_TYPE: 'tipo-de-conta',
  ACCOUNT: 'conta',
  REGISTRATION_DATA: 'dados-cadastrais',
  CHOOSE_VALIDATION: 'forma-de-validacao',
  CODE_VALIDATION_SMS: 'validacao-sms',
  CODE_VALIDATION_MAIL: 'validacao-email',
  HEALTH_PLAN: 'selecionar-plano',
  HEALTH_PLAN_IDENTIFIER: 'identificador-do-plano-de-saude',
  CORPORATE_BENEFIT_IDENTIFIER: 'identificador-do-beneficio-corporativo',
  WHITELABEL_IDENTIFIER: 'identificador-clinica-whitelabel',
  SAAS_IDENTIFIER: 'identificador-clinica-saas',
  DOCPASS_IDENTIFIER: 'identificador-clinica-docpass',
  REDE_CONEXA_IDENTIFIER: 'identificador-clinica-rede-conexa',
  CORPORATE_BENEFIT: 'beneficio-corporativo',
  CREATE_PASSWORD: 'criar-senha',
}

export const STEPS_EVENT_NAME = {
  cpf: 'check_cpf',
  'tipo-de-conta': 'account_type',
  conta: 'account',
  'dados-cadastrais': 'registration_data',
  'forma-de-validacao': 'choose_validation',
  'validacao-sms': 'code_validation_sms',
  'validacao-email': 'code_validation_email',
  'selecionar-plano': 'health_plan',
  'identificador-do-plano-de-saude': 'health_plan_identifier',
  'identificador-do-beneficio-corporativo': 'corporate_benefit_identifier',
  'beneficio-corporativo': 'corporate_benefit',
  'criar-senha': 'create_password',
}

export const SEND_TO = ['DEFAULT_GTAG_INSTANCE', 'DEFAULT_CLARITY_INSTANCE']

export const ACCOUNT_TYPE_EVENT_NAME = {
  HEALTH_PLAN: 'health_plan',
  CORPORATE_BENEFIT: 'corporate_benefit',
  PRIVATE_COVERAGE: 'private_coverage',
}

export const ERROR_MSG_BY_IDENTIFIER_CLINIC = {
  email: ERROR_MESSAGES.INVALID_EMAIL,
  cpf: ERROR_MESSAGES.INVALID_CPF,
}

export const CLINIC_TYPE = {
  BENEFICIO_CORPORATIVO: 'CORPORATE_BENEFIT',
  PLANO_SAUDE: 'HEALTH_PLAN',
}
